
const ProjectModel = [
  {
    id: 1,
    title: "Tenzies",
    titleColor: "#FF014E",
    liveUrl: "https://codedken.github.io/tenzies/",
    desc: "Tenzies is a dice-rolling game app built with Reactjs. I just a simple fun app.",
    btnText: "Click to go live",
    githubLink: "https://github.com/codedken/tenzies",
  },
  // {
  //   id: 2,
  //   title: "Giftor",
  //   titleColor: "#66B848",
  //   liveUrl: "https://play.google.com/store/apps/details?id=com.chekslate.giftor",
  //   desc: "Giftor is a random picker app for sharing gifts amongs family and friends etc.  It’s built with flutter and dart.",
  //   btnText: "",
  //   githubLink: "https://github.com/codedken/giftor",
  // },
  // {
  //   id: 3,
  //   title: "Notist",
  //   titleColor: "#47C5FB",
  //   liveUrl: "https://play.google.com/store/apps/details?id=com.chekslate.notist",
  //   desc: "Notist a simple note-taking app buiit with flutter and dart. Firebase for backend.",
  //   btnText: "",
  //   githubLink: "https://github.com/codedken/notist",
  // },
  {
    id: 4,
    title: "Animated Menu",
    titleColor: "#FFD900",
    liveUrl: "https://codedken.github.io/Animated_menu/",
    desc: "Animated Menu is an elegant interactive side menu build with Reactjs.",
    btnText: "Click to go live",
    githubLink: "https://github.com/codedken/Animated_menu",
  },
  {
    id: 5,
    title: "Light Bulb",
    titleColor: "#08D0F9",
    liveUrl: "https://codedken.github.io/light-bulb/",
    desc: "Light Bulb is a replica of the traditional electric bulb, it’s built with html, css and javascript.",
    btnText: "Click to go live",
    githubLink: "https://github.com/codedken/light-bulb",
  },
  {
    id: 6,
    title: "Airplane in motion",
    titleColor: "#FF014E",
    liveUrl: "https://codedken.github.io/airplane-in-motion/",
    desc: "Built with html and css only. An moving airplane on a runway that takes off when the cursor is left-clicked and held down.",
    btnText: "Click to go live",
    githubLink: "https://github.com/codedken/airplane-in-motion",
  },
];

export default ProjectModel;
